import { render, staticRenderFns } from "./Contratacao.vue?vue&type=template&id=21001b44"
import script from "./Contratacao.vue?vue&type=script&lang=js"
export * from "./Contratacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports